// Action types
export const UPLOAD_REQUEST = "SET_UPLOAD_LOADING";
export const UPLOAD_SUCCESS = "GET_UPLOAD_SUCCESS";
export const UPLOAD_FAILURE = "GET_UPLOAD_FAILURE";
export const UPDATE_PROGRESS = "UPDATE_UPLOAD_PROGRESS";

// Action creators
export const uploadRequest = () => ({ type: UPLOAD_REQUEST });
export const uploadSuccess = () => ({ type: UPLOAD_SUCCESS });
export const uploadFailure = (error) => ({
    type: UPLOAD_FAILURE,
    payload: error,
});
export const updateUploadProgress = (progress) => ({
    type: UPDATE_PROGRESS,
    payload: progress,
});
export const cleanError = () => ({ type: 'SET_ERROR_FALSE' })
